import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ClinicsPage from "@/pages/ClinicsPage";
import ResultsPage from "@/pages/ResultsPage";
import BlogPage from "@/pages/BlogPage";
import BlogPost from "@/pages/BlogPost";
import CityPage from "@/pages/CityPage";
import AdminPage from "@/pages/AdminPage";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <HelmetProvider>
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/clinics" element={<ClinicsPage />} />
                            <Route path="/results" element={<ResultsPage />} />
                            <Route path="/blog" element={<BlogPage />} />
                            <Route path="/blog/:slug" element={<BlogPost />} />
                            <Route path="/city/:city" element={<CityPage />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                            <Route path="/admin" element={<AdminPage />} />
                            <Route path="*" element={<NotFound />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
                <Toaster
                    position="bottom-center"
                    toastOptions={{
                        style: {
                            background: "#111111",
                            color: "#FAFAFA",
                            border: "1px solid #C5A880",
                            borderRadius: "0",
                            fontFamily: "Manrope, sans-serif",
                            letterSpacing: "0.05em",
                        },
                    }}
                />
            </div>
        </HelmetProvider>
    );
}

export default App;
